import * as types from '../action-types';

const setOptionalPaymentDetailsConsentConfiguration = optionalPaymentDetailsConsentConfiguration => ({
  type: types.SET_OPTIONAL_PAYMENT_DETAILS_CONSENT_CONFIGURATION,
  optionalPaymentDetailsConsentConfiguration,
});

export default setOptionalPaymentDetailsConsentConfiguration;
